module.exports = __webpack_public_path__ + "img/SOUTHERN_GREAT_PLAIN.9bf1de8d.jpg";